import {IntlShape, MessageDescriptor, defineMessages} from 'react-intl'

/**
 * Catálogo de la Bandeja de entrada (`/inbox`). Namespace `comms.inbox.*`, con
 * el resto de mensajería (Fase 1.9).
 *
 * La pantalla venía **mezclada**: parte en inglés y parte en español
 * hardcodeado. Donde el fuente estaba en español se redactó el inglés como
 * fuente (guía §17.6). El español se normalizó al registro de usted del resto de
 * la app: el original decía «No tenés mensajes», con voseo, que no encaja con
 * «Seleccione», «Escriba», etc.
 *
 * No se traducen: el asunto, el remitente ni el extracto de un correo — son
 * datos que llegan de la API.
 */
export const INBOX_MESSAGES = defineMessages({
  title: {id: 'comms.inbox.title', defaultMessage: 'Messages'},
  breadcrumbSuffix: {id: 'comms.inbox.breadcrumb', defaultMessage: 'inbox'},
  newMessage: {id: 'comms.inbox.action.newMessage', defaultMessage: 'New Message'},
  noSubject: {id: 'comms.inbox.noSubject', defaultMessage: '(no subject)'},
  empty: {id: 'comms.inbox.empty', defaultMessage: 'You have no messages'},
  searchPlaceholder: {id: 'comms.inbox.search', defaultMessage: 'Search...'},

  // ── Redactar ──
  compose: {id: 'comms.inbox.compose.title', defaultMessage: 'Compose Message'},
  subjectPlaceholder: {id: 'comms.inbox.compose.subject', defaultMessage: 'Subject'},
  send: {id: 'comms.inbox.compose.send', defaultMessage: 'Send'},

  // ── Un mensaje ──
  reply: {id: 'comms.inbox.message.reply', defaultMessage: 'Reply'},
  replyAll: {id: 'comms.inbox.message.replyAll', defaultMessage: 'Reply to all'},
  forward: {id: 'comms.inbox.message.forward', defaultMessage: 'Forward'},

  // ── Reusadas ──
  home: {id: 'shell.notifications.home', defaultMessage: 'Home'},
  search: {id: 'common.action.search', defaultMessage: 'Search'},
  errorWithMessage: {id: 'common.error.withMessage', defaultMessage: 'Error: {message}'},
})

/**
 * Cabeceras de correo: `To:`, `Cc:`, `Bcc:`. Son abreviaturas estándar del
 * protocolo y se escriben igual en los dos idiomas.
 */
export const MAIL_HEADERS = {to: 'To:', cc: 'Cc:', bcc: 'Bcc:'} as const

/** Separador del breadcrumb. */
export const BREADCRUMB_DASH = ' - '

type Labels = Record<string, MessageDescriptor>

/** Refleja `NAV_ITEMS`: las carpetas del panel lateral. */
const NAV_LABEL: Labels = defineMessages({
  Inbox: {id: 'MENU.item.inbox', defaultMessage: 'Inbox'},
  Marked: {id: 'comms.inbox.folder.marked', defaultMessage: 'Marked'},
  Draft: {id: 'comms.inbox.folder.draft', defaultMessage: 'Draft'},
  Send: {id: 'comms.inbox.folder.sent', defaultMessage: 'Sent'},
  Trash: {id: 'comms.inbox.folder.trash', defaultMessage: 'Trash'},
}) as Labels

/** Nombre traducido de una carpeta. El valor inglés sigue siendo la clave de estado. */
export const inboxNavLabel = (intl: IntlShape, title?: string | null) =>
  title && NAV_LABEL[title] ? intl.formatMessage(NAV_LABEL[title]) : title ?? ''
